import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AnimatePresence, motion } from "framer-motion";
import { StableOutlet } from "@/components/StableOutlet";

export const Route = createFileRoute("/_app/_meal-page")({
  component: MealPageLayout,
});

function MealPageLayout() {
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        className="flex h-full flex-col"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.15 }}
      >
        <StableOutlet>
          <Outlet />
        </StableOutlet>
      </motion.div>
    </AnimatePresence>
  );
}
